export default __webpack_public_path__ + "static/media/me.b5183252.jpg";